module.exports = __webpack_public_path__ + "static/amrit-series-text-bubble-2fcb12d2206838f5c024887b6f80387c.svg";